import { ChangeDetectionStrategy, Component } from '@angular/core';
import { MatDialogClose } from '@angular/material/dialog';
import { BaseComponent, IconButtonComponent } from 'clicklease-ui-elements';

@Component({
    selector: 'rose-portal-close-modal-button',
    standalone: true,
    imports: [
        MatDialogClose,
        IconButtonComponent
    ],
    templateUrl: 'close-modal-button.component.html',
    styleUrl: 'close-modal-button.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CloseModalButtonComponent extends BaseComponent { }
